import { useState } from "react";
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import Stack from '@mui/material/Stack';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import RegionSelect from './areaComponents/RegionSelect';
import StateSelect from './areaComponents/StateSelect';
import BboxSelect from './areaComponents/BboxSelect';
import OtherAreaSelect from './areaComponents/OtherAreaSelect';

export default function AreaSelection(props) {
  const { userParams, setUserParams, showAreaSelection, setShowAreaSelection, setShowGoButton } = props;
  const [ areaType, setAreaType ] = useState(userParams.areaType);

  const handleTypeChange = (event) => {
    const newAreaType = event.target.value;
    setAreaType(newAreaType);
    setShowGoButton(true);
  };

  return (
    <Card sx={{ boxShadow: 0, backgroundColor: (theme) => theme.palette.grey[100]  }}>
      <CardHeader
        action={ 
          <IconButton 
              aria-label="expand"
              size="small"
          > 
              {showAreaSelection ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />} 
          </IconButton> 
        }
        title={
          <Typography
            component="h2"
            variant="subtitle"
            sx={{ fontSize: 16 }}
          >
            {"Area Selection"}
          </Typography>
        }
        sx={{ pl: 0, pr: 0, pb: 0 }}
        onClick={() => setShowAreaSelection(!showAreaSelection)} 
      />

      <Collapse in={showAreaSelection} timeout="auto" unmountOnExit>
        <CardContent sx={{ p: '0 !important' }}>
          <Stack direction="row" spacing={2} sx={{ pt: 1 }}>
              <ToggleButtonGroup
                  value={areaType}
                  exclusive
                  orientation="vertical"
                  onChange={handleTypeChange}
              >
                  <ToggleButton size="small" value="region" >
                      Region
                  </ToggleButton>
                  <ToggleButton size="small" value="state">
                      State
                  </ToggleButton>
                  <ToggleButton size="small" value="bbox">
                      Box
                  </ToggleButton>
                  <ToggleButton size="small" value="other" sx={{ whiteSpace: 'nowrap' }}>
                      More ...
                  </ToggleButton>
              </ToggleButtonGroup>

              {areaType === 'region' &&
                <RegionSelect 
                  userParams={userParams}
                  setUserParams={setUserParams}
                  setShowGoButton={setShowGoButton}
                />
              }
              {areaType === 'state' &&
                <StateSelect 
                  userParams={userParams}
                  setUserParams={setUserParams}
                  setShowGoButton={setShowGoButton}
                />
              }
              {areaType === 'bbox' &&
                <BboxSelect 
                  userParams={userParams}
                  setUserParams={setUserParams}
                  setShowGoButton={setShowGoButton}
                />
              }
              {areaType === 'other' &&
                <OtherAreaSelect 
                  userParams={userParams}
                  setUserParams={setUserParams}
                  setShowGoButton={setShowGoButton}
                />
              }
          </Stack>
        </CardContent>
      </Collapse>
    </Card>
  )          
}